import { CommonMetadata, FileItem, FileWithMetadata, FolderWithMetadata } from 'shared-utils/file-system';

import { FileInfo } from '../../communication';

export function createFileItem(file: FileInfo, parentPath: string): FileItem {
  if (file.type === 'directory') {
    return createFolderWithMetadata(file, parentPath);
  } else {
    return createFileWithMetadata(file, parentPath);
  }
}

function createFileWithMetadata(file: FileInfo, parentPath: string): FileWithMetadata {
  return {
    type: 'file',
    parentId: parentPath,
    id: file.path,
    label: file.filename,
    metadata: getCommonMetadata(file),
    applicationMetadata: file.metadata,
    staticMetadata: {},
  };
}

function createFolderWithMetadata(file: FileInfo, parentPath: string): FolderWithMetadata {
  return {
    type: 'folder',
    parentId: parentPath,
    id: file.path,
    label: file.filename,
    metadata: getCommonMetadata(file),
  };
}

function getCommonMetadata(file: FileInfo): CommonMetadata {
  return {
    createdAt: file.dateCreated,
    updatedAt: file.dateModified,
    size: file.size?.toString() ?? '', // TODO IVIEW-6108 Parse size from number -> string with unit (162873 -> 159 ko)
  };
}
